module.exports = __webpack_public_path__ + "media/promo/hochland/images/l3-cafcc15077153c3eee8e1ff55892b46b.png";